module.exports = __webpack_public_path__ + "static/kasuien03-8ac3bc4e05a11f852ef43f30fb55fcd7.jpg";